import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "userHelp",
    title: "User Help",
    icon: "ri-customer-service-line",
    path: "/user/help",
    activePaths: ["/user/help"],
  },
  {
    id: "history",
    title: "History",
    icon: "ri-chat-history-line",
    path: "/issue/list",
    activePaths: ["/issue/list"],
  },
];

export default function UserHelpLayout({ children }) {
  return (
    <>
      <ModuleHeader tabs={tabs} />

      {children}
    </>
  );
}
